import { Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'roundNumber'
})

export class RoundNumberPipe implements PipeTransform {
  roundNumber(num: number|string, digits: number = 1, allowNegativeNumbers: boolean = false) {
    if(typeof num === 'string' && num.includes(',')){
      const clean = parseFloat(num.replace(/,/g, ''));
      num = (Number.isNaN(clean)) ? 0 : clean;
    }
    const pow = Math.pow(10, digits);
    const round = Math.round(+num * pow) / pow;
    if (Number.isNaN(round) || (!allowNegativeNumbers && round < 0) ) return 0;
    return round;
  }

  transform(value: number, digits: number, allowNegativeNumbers: boolean, ...args: unknown[]): unknown {
    return this.roundNumber(value, digits, allowNegativeNumbers)
  }
}